import Menu from '@/global/components/MenuV2'
import { useAuth } from '@/hooks'
import { hasPermission } from '@/hooks/useBackendMenu'
import { CategoriaEnum } from '@acme/auth'
import { SN, StatusAprovacao } from '@acme/core'
import { Grid } from '@mui/material'
import dayjs from 'dayjs'
import { FormField, FormFile } from 'global/components/Form'
import { SelectFuncionarios } from 'global/components/Selects'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ocorrencia, ocorrenciaTipoToPermission } from 'service/api'
import { match } from 'ts-pattern'

export default function FormDetalhesAfastamento() {
    const ocorrencias = ocorrencia.useFetch().data || []
    const { watch, setValue } = useFormContext()
    const {
        decoded: { categoria },
    } = useAuth()

    const [dataInicial, dataFinal, dias, funcionarioId, statusAprovacao] =
        watch([
            'dataInicial',
            'dataFinal',
            'dias',
            'funcionarioId',
            'statusAprovacao',
        ])

    const isDiasFocado = document.activeElement?.id === 'field-dias'
    const isDataFocado = ['field-data-final', 'field-data-inicial'].includes(
        document.activeElement?.id ?? '',
    )

    useEffect(() => {
        if (isDiasFocado) {
            if (!dataInicial || dias < 1) return
            const dataFinal = dayjs(dataInicial)
                .add(dias - 1, 'day')
                .format('YYYY-MM-DD')
            setValue('dataFinal', dataFinal)
        }
        if (isDataFocado) {
            if (!dataInicial || dayjs(dataFinal).isBefore(dataInicial)) return
            setValue('dias', dayjs(dataFinal).diff(dataInicial, 'day') + 1)
        }
    }, [dataInicial, dataFinal, isDiasFocado, isDataFocado, setValue, dias])

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={12}>
                <SelectFuncionarios
                    defaultValues={[funcionarioId]}
                    disabled
                    helperText=" "
                    size="medium"
                    width={'100%'}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="ocorrenciaId"
                    label="Ocorrência"
                    select
                    required
                >
                    {ocorrencias?.map(
                        ({ codigo, id, descricao, tipo, atalho }, index) => (
                            <Menu.Item
                                key={index}
                                value={id}
                                disabled={
                                    !hasPermission([
                                        'update',
                                        ocorrenciaTipoToPermission(tipo),
                                    ]) ||
                                    (categoria === CategoriaEnum.Supervisor &&
                                        SN.isFalse(atalho))
                                }
                            >
                                {`${
                                    codigo < 999 ? '0' + codigo : codigo
                                }: ${descricao}`}
                            </Menu.Item>
                        ),
                    )}
                </FormField>
            </Grid>
            <Grid item xs={5}>
                <FormField
                    id="field-data-inicial"
                    name="dataInicial"
                    label="Data inicial"
                    type="date"
                    required
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={5}>
                <FormField
                    required
                    id="field-data-final"
                    name="dataFinal"
                    label="Data final"
                    type="date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={2}>
                <FormField
                    id="field-dias"
                    name="dias"
                    label="Dias"
                    type="number"
                    disabled={!dataInicial}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile name="fileUrl" disabled />
            </Grid>
            {match(statusAprovacao)
                .with(StatusAprovacao.PENDENTE, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Motivo da inclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .with(StatusAprovacao.PENDENTE_EXCLUSAO, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="MotivoExclusao.motivo"
                            label="Motivo da exclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .otherwise(() => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Justificativa"
                            multiline
                            disabled
                        />
                    </Grid>
                ))}
        </Grid>
    )
}
